import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IPaymentReviewId } from "./paymentReviewId.types"
import { PaymentReviewId } from "./paymentReviewId"

export const PaymentReviewIdParser: IParser<
  IPaymentReviewId,
  IPaymentReviewId
> = {
  toDomain(data: IPaymentReviewId): IPaymentReviewId {
    try {
      const reviewName =
        data.type === "manual"
          ? "Manual review ID - " + data.id
          : "Automated review ID - " + data.id
      return new PaymentReviewId(data.id, reviewName, data.type)
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
